import { createSignal, onCleanup } from 'solid-js'

/** Acompanha a largura do elemento, que e o que o SVG precisa saber para ter eixo. */
export function useWidth(): [() => number, (el: HTMLElement) => void] {
    const [width, setWidth] = createSignal(0)

    const observe = (el: HTMLElement) => {
        const ro = new ResizeObserver((entries) => {
            const box = entries[0]?.contentRect
            if (box) {
                setWidth(box.width)
            }
        })
        ro.observe(el)
        onCleanup(() => ro.disconnect())
    }

    return [width, observe]
}
